
export function loadCartNavDropdownContent() {
    return import(/* webpackChunkName: "CartNavDropdownContent" */
        './CartNavDropdownContent').then(({ default: CartNavDropdownContent }) => CartNavDropdownContent);
}

